import { Component, OnInit } from '@angular/core';

import { BaseComponent } from '../../base/base.component';
import { WizardService } from '../../../services/wizard/wizard.service';
import { EventService } from '../../../services/event/event.service';

import moment_ from 'moment-timezone';
const moment = moment_;
interface IDateTime {
    start: string;
    end: string;
}

declare var $: any;
@Component({
    selector: 'wizard-suggestions',
    templateUrl: './suggestions.component.html',
    styleUrls: ['../../form-styles.scss', './suggestions.component.scss']
})
export class SuggestionsComponent extends BaseComponent implements OnInit {
    private cacheUpdated = false;
    public viewMore = false;
    public suggestedTimes: IDateTime[] = [{ start: '', end: '' }];
    public selectedTimeStart: 'let-them-decide' | string = '';
    public timezone = moment.tz.guess();

    constructor(public wizardService: WizardService, public eventService: EventService) {
        super();
    }

    ngOnInit() {
        const { suggestedTimes } = this.wizardService.responseData;
        this.suggestedTimes = suggestedTimes.map((time) => {
            return {
                start: time.start,
                end: time.end
            };
        });
        this.eventService.shouldResetOnBack = true;
        this.eventService.isNextDisabled = true;
        this.timezone = this.wizardService.currentUser.timezone || this.timezone;
    }

    ngAfterViewInit() {
        $('.ui.checkbox').checkbox();
    }

    public onViewMore() {
        this.viewMore = true;
    }

    public handleSelectTime(value: IDateTime) {
        this.selectedTimeStart = value.start;

        /**
         * Because selecting this option overwrites wizardService.options, we first want to
         * save the original values, in case the user goes back, or decides to select the 'schedule' option after
         */
        if (!this.cacheUpdated) {
            this.updateDataCache();
        }

        this.wizardService.updateOptions({
            dateStart: moment(value.start),
            timeStart: moment(value.start),
            isSpecificTime: true
        });

        /** Skip the Confirmation screen and create the meeting right away */
        this.createMeeting();

        this.eventService.isNextDisabled = false;
    }

    public handleSelectLetThemDecide(value: 'let-them-decide') {
        this.selectedTimeStart = value;

        this.wizardService.updateOptions({
            isSpecificTime: false
        });
        this.eventService.overrideNextAction('Next', { nextPage: 'confirmation' });
        // Restore the original date and time values, if the user selects 'let them decide' AFTER choosing a time slot
        if (this.cacheUpdated) {
            this.wizardService.mergeCacheIntoOptions();
        }

        this.eventService.isNextDisabled = false;
    }

    private updateDataCache() {
        const { options } = this.wizardService;
        this.wizardService.updateDataCache({
            dateStart: options.dateStart,
            timeStart: options.timeStart,
            isSpecificTime: options.isSpecificTime
        });
        this.cacheUpdated = true;
    }

    private createMeeting() {
        /** TODO: Use payloadKeys from BE instead of hard coding them here */
        this.eventService.overrideNextAction('Send', {
            api: {
                endPoint: 'create-meeting',
                payloadKeys: [
                    'subject',
                    'dateStart',
                    'dateEnd',
                    'type',
                    'travelTime',
                    'meetingLength',
                    'locations',
                    'description',
                    'contacts',
                    'room',
                    'taskId',
                    'availabilityWindows'
                ]
            }
        });
    }
}
